import type { SVGProps } from "react";

/**
 * checkmark-2-small
 * @category Interface General
 */
export default function IconCheckmark2Small(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M6.75 13.0625L9.9 16.25L17.25 7.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
